import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IAuthData } from '../../initialState';

export interface ICompanyEditRequestAction {
  data: {
    VAT: string;
    companyEmail: string;
    companyName: string;
    headQuarters: {
      city: string;
      number: number;
      postcode: number;
      street: string;
    };
    iban?: string;
    intervention_partnership_id?: string;
    missionLanguages: string[];
    password: string;
    trader_id?: string;
    website?: string;
  };
  functions: {
    error: (err: any) => void;
    goBack: () => void;
    success: () => void;
  };
}

function editRequest(
  draft: Draft<IAuthData>,
  _: PayloadAction<ICompanyEditRequestAction>,
) {
  draft.editCompany.config.isLoading = true;
}

export default editRequest;
